import React, { Component } from "react";

class Rules extends Component {
  render() {
    return (
      <div>
        <h2 id="sub-title">The rules are simple...</h2>
        <p id="rules-1">1. rock smashes scissors.</p>
        <p id="rules-2">2. scissors slice up paper.</p>
        <p id="rules-3">3. paper smothers rock.</p> <br /> <br />
      </div>
    );
  }
}

export default Rules;